import { message } from "antd";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { API_ERROR_MESSAGE, ROUTES } from "@/constants";
import { useAppSelector } from "@/store/hooks";
import { buildAuthRouteTarget } from "@/utils/auth-redirect";
import { buildCurrentPath } from "@/utils/location";

const AUTH_ROUTE_PATHS = new Set<string>([
  ROUTES.LOGIN,
  ROUTES.FORGOT_PASSWORD,
]);

export const AppSessionBridge = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionExpiredNoticeId = useAppSelector(
    (state) => state.auth.sessionExpiredNoticeId,
  );
  const lastHandledNoticeRef = useRef(0);

  useEffect(() => {
    if (
      sessionExpiredNoticeId === 0 ||
      sessionExpiredNoticeId === lastHandledNoticeRef.current
    ) {
      return;
    }

    lastHandledNoticeRef.current = sessionExpiredNoticeId;
    message.warning(API_ERROR_MESSAGE.SESSION_EXPIRED);

    if (AUTH_ROUTE_PATHS.has(location.pathname)) {
      return;
    }

    const currentPath = buildCurrentPath(location);

    navigate(buildAuthRouteTarget(ROUTES.LOGIN, currentPath), {
      replace: true,
      state: { from: currentPath },
    });
  }, [location, navigate, sessionExpiredNoticeId]);

  return null;
};
